module.exports = __webpack_public_path__ + "img/img_042@2x.4965f90b.png";